import { useRef, useLayoutEffect } from 'react';

export function useEvent<T extends (...args: any[]) => any>(callback: T): T {
  // @ts-expect-error
  const ref = useRef({
    stableFn: ((...args) => ref.current.callback(...args)) as T,
    callback,
  });

  useLayoutEffect(() => {
    ref.current.callback = callback;
  });

  return ref.current.stableFn;
}
